/**
 * Project : workspace
 * File    : BusinessSaleScreen.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.business.sale

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.GridItemSpan
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import com.parmartechnologies.business.feature.business.viewModel.BusinessViewModel
import com.parmartechnologies.commerce.feature.cart.viewModel.CartViewModel
import com.parmartechnologies.commerce.feature.inventory.product.viewModel.ProductViewModel
import com.parmartechnologies.commerce.feature.inventory.viewModel.inventory.InventoryViewModel
import com.parmartechnologies.core.feature.inventory.inventory.model.Inventory
import com.parmartechnologies.core.navigation.NavigationParam
import component.button.DefaultButton
import component.empty.EmptyData
import component.input.SearchBar
import component.loader.AppLoader
import component.navigation.TopNavBar
import component.product.ProductCard
import locale.localization
import navigation.AppNavigator
import navigation.route.inventory.InventoryNavRoute
import navigation.route.sale.SaleNavRoute
import theme.ThemeColor

/**
 * Represents the business sale screen class.
 */

class BusinessSaleScreen {
    @Composable
    fun Content() {
        val businessViewModel = BusinessViewModel()
        val myBusiness = businessViewModel.myBusiness.collectAsState()
        val viewModel = CartViewModel(business = myBusiness.value)
        val productViewModel = ProductViewModel(business = myBusiness.value)
        val invViewModel = InventoryViewModel(business = myBusiness.value)
        val allProducts = productViewModel.allProduct.collectAsState()
        val searchQuery = productViewModel.searchQuery.collectAsState()
        val allInventory = invViewModel.allInventory.collectAsState()

        val allCartItems = viewModel.cartItems.collectAsState()
        var selectedProductId by remember { mutableStateOf("") }
        val navigationParam = AppNavigator.shared().getNavigationParam()
        LaunchedEffect(key1 = Unit) {
            productViewModel.loadProduct()
            viewModel.loadCart(navigationParam)
            invViewModel.loadInventoryForBusiness(myBusiness.value._id)
        }
        Column(modifier = Modifier.fillMaxSize().background(ThemeColor.shared().defaultBakground)) {
            TopNavBar(title = "Sale", NavigationParam(), onBackPress = {
                AppNavigator.shared().goBack()
            }, onClickCart = {
                AppNavigator.shared().navigate(SaleNavRoute.BUSINESS_CART,navigationParam)
            })
            AppLoader(viewModel)
            SearchBar(
                productViewModel,
                searchQuery.value,
                localization().product.productsSearchPlaceholder
            )
            LazyVerticalGrid(
                columns = GridCells.Adaptive(minSize = 180.dp),
                modifier = Modifier.weight(1f).padding(
                    start = 8.dp,
                    end = 8.dp,
                    bottom = 0.dp
                ),
            ) {
                item(span = { GridItemSpan(maxCurrentLineSpan) }) {
                    if (allProducts.value.isEmpty()) {
                        EmptyData(viewModel = viewModel)
                        DefaultButton(
                            "Create New Product",
                            onClick = {
                                AppNavigator.shared().navigate(InventoryNavRoute.Product.CREATE)
                            })
                    } else {
                        Box(
                            modifier = Modifier
                                .height(50.dp)
                                .padding(start = 8.dp, end = 8.dp)
                                .background(
                                    ThemeColor.shared().cardBackground,
                                    shape = RoundedCornerShape(10.dp)
                                ),
                            contentAlignment = Alignment.Center
                        ) {
                            Text(
                                text = "${localization().product.productsTotal} ${allProducts.value.count()} ${localization().product.productsProduct}",
                                maxLines = 2,
                                overflow = TextOverflow.Ellipsis,
                                modifier = Modifier
                                    .wrapContentHeight().fillMaxWidth(),
                                textAlign = TextAlign.Center,
                                color = ThemeColor.shared().PrimaryColor
                            )
                        }
                    }
                }
                items(count = allProducts.value.count()) {
                    val prd = allProducts.value[it]
                    val inv =
                        allInventory.value.filter { inventory: Inventory -> inventory.ProductID == prd._id }
                    ProductCard(
                        product = prd,
                        viewModel = viewModel,
                        param = navigationParam,
                        inventory = inv,
                        selectedProductId = selectedProductId,
                        onClickSelect = {
                            selectedProductId = it._id
                        },
                        onClick = { }
                    ).content()
                }
            }
        }
    }
}